import { render, staticRenderFns } from "./timer-bar.vue?vue&type=template&id=a1a2af10&shadow"
import script from "./timer-bar.vue?vue&type=script&lang=js&shadow"
export * from "./timer-bar.vue?vue&type=script&lang=js&shadow"
function injectStyles (context) {
  
  var style0 = require("./timer-bar.vue?vue&type=style&index=0&id=a1a2af10&prod&lang=scss&shadow")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  ,true
)

export default component.exports